import { Injector } from '@angular/core';
import { random } from '@sama/micro-dash';
import { SubpointEventInfo } from '../../../cross-team-shared/misc-services/events/mouse-event.service';
import { Dimensions } from '../../../cross-team-shared/types/misc';
import { VectorLayerEditMode } from '../../../cross-team-shared/types/tool-modes';
import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';
import {
  calculateCuboidVertices,
  isValidPartialCuboid,
} from '../shapes/cuboid/cuboid-solver';
import { CuboidSubpointTranslationHelper } from '../shapes/cuboid/cuboid-subpoint-translation-helper';
import { VectorDragHandler } from '../tools/shared/drag-handlers/vector-drag-handler';
import { ShapeHelper } from './shape-helper';

export class Cuboid2DHelper extends ShapeHelper {
  override arePointsValid(points: Point2D[]) {
    return isValidPartialCuboid(points);
  }

  override doesSubpointMoveWithShape(index: number) {
    return index > 0;
  }

  override getSingleSubpointDragHandler(
    eventInfo: SubpointEventInfo,
    _editMode: VectorLayerEditMode,
    injector: Injector,
  ) {
    return new VectorDragHandler(
      eventInfo.event,
      injector,
      new CuboidSubpointTranslationHelper(
        eventInfo.shapeStore,
        eventInfo.subpointIndex,
        injector,
      ),
      {
        restrictInteractions: true,
      },
    );
  }

  override makeRandomPoints(imageSize: Dimensions): Point2D[] {
    const maxX = imageSize.width - 1;
    const maxY = imageSize.height - 1;

    const vanishing: Point2D = [
      random(maxX, false),
      random(imageSize.height / 2, false),
    ];
    const first: Point2D = [
      random(maxX, false),
      random(vanishing[1], maxY, false),
    ];
    const third: Point2D = [
      random(maxX, false),
      random(vanishing[1], maxY, false),
    ];

    const second: Point2D = [
      random(Math.min(first[0], third[0]), Math.max(first[0], third[0]), false),
      random(Math.max(first[1], third[1]), maxY, false),
    ];
    const fourth: Point2D = [second[0], random(vanishing[1], second[1], false)];

    return [vanishing, first, second, third, fourth];
  }

  override getMinPoints() {
    return 5;
  }

  override getBoundingPoints(points: Point2D[]) {
    return super.getBoundingPoints(
      // cuboid vertices will always be defined because we pass in 5 points
      calculateCuboidVertices(points) as Point2D[],
    );
  }
}
